import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance, axiosNewApiInstance } from "../../services/api.js";

// Get list of existing clients +
export const getClientsList = createAsyncThunk(
  "clients/getClientsList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/customers/`);
      // console.log("getClientsList", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create new client +
export const createNewClient = createAsyncThunk(
  "clients/createNewClient",
  async (clientInfo, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/customers/`,
        clientInfo
      );
      console.log("response data in createNewClient", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Upload clients list from Excel file +
export const uploadClientsFromExcel = createAsyncThunk(
  "clients/uploadClientsFromExcel",
  async (formData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/customers/import`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("uploadClientsFromExcel", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Delete client +
export const deleteClient = createAsyncThunk(
  "clients/deleteClient",
  async (clientId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/customers/${clientId}`
      );
      console.log("deleteClient", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Get client detailed info - НОВА АРІ +
export const getClientInfo = createAsyncThunk(
  "clients/getClientInfo",
  async (recordId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/records/${recordId}/details`
      );
      console.log("response data in getClientInfo", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get repair history +
export const getRepairHistory = createAsyncThunk(
  "clients/getRepairHistory",
  async ({ carId }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/records/vehicle/${carId}/repair-history`
      );
      console.log("getRepairHistory", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get roadmap history +
export const getRoadmapHistory = createAsyncThunk(
  "clients/getRoadmapHistory",
  async ({ recordId }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/records-history/${recordId}`
      );
      console.log("getRoadmapHistory", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create new client and assign him to the Record +
export const createClient = createAsyncThunk(
  "clients/createClient",
  async (clientInfo, thunkAPI) => {
    try {
      const { recordId, ...client_info } = clientInfo;

      const response = await axiosNewApiInstance.post(
        `/api/v1/records/${recordId}/customer`,
        client_info
      );

      console.log("response data in createClient", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Update Client +
export const updateClient = createAsyncThunk(
  "clients/updateClient",
  async (clientDataToUpdate, thunkAPI) => {
    try {
      const { client_id, ...dataToUpdate } = clientDataToUpdate;

      const response = await axiosNewApiInstance.patch(
        `/api/v1/customers/${client_id}`,
        dataToUpdate
      );
      console.log("updateClient", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Add debts to clients +
export const addClientsDebt = createAsyncThunk(
  "clients/addClientsDebt",
  async (debtData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/customers/debt/bulk`,
        debtData
      );
      console.log("addClientsDebt", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// add car +
export const addCar = createAsyncThunk(
  "clients/addCar",
  async (carInfo, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/vehicles/`,
        carInfo
      );

      console.log("response data in addCar", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// update car +
export const updateCar = createAsyncThunk(
  "clients/updateCar",
  async (carDataToUpdate, thunkAPI) => {
    try {
      const { vehicle_id, ...dataToUpdate } = carDataToUpdate;

      const response = await axiosNewApiInstance.patch(
        `/api/v1/vehicles/${vehicle_id}`,
        dataToUpdate
      );
      console.log("updateCar", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Delete car
export const deleteCar = createAsyncThunk(
  "clients/deleteCar",
  async ({ car_id, comment }, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const response = await axiosInstance.delete(
        `/crm/delete_car/${car_id}`,
        // {comment},

        {
          headers: {
            "company-id": serviceId,
          },
          data: { comment },
        }
      );
      console.log("deleteCar", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Create Notification
export const createNotification = createAsyncThunk(
  "clients/createNotification",
  async (noteDataToCreate, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const response = await axiosInstance.post(
        `/crm/reminder/notify_client/`,
        noteDataToCreate,
        {
          headers: {
            "company-id": serviceId,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("response data in createNotification", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Create car without client
export const createCarWithoutClient = createAsyncThunk(
  "clients/createCarWithoutClient",
  async (carInfo, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const response = await axiosInstance.post(`/crm/car_save/`, carInfo, {
        headers: {
          "company-id": serviceId,
          "Content-Type": "application/json",
        },
      });

      console.log("createCarWithoutClient", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
